import React, { useEffect, useRef, useState } from "react";
import { SearchOutlined } from "@mui/icons-material";
import { Link, NavLink } from "react-router-dom";
import axios from "../.././API/axios";

const GobalSearch = () => {
	const [inputValue, setInputValue] = useState("");
	const [isLoading, setIsLoading] = useState(true);
	const [totalPages, setTotalPages] = useState(1);
	const [searchUser, setSearchUser] = useState([]);
	const [searchComp, setSearchComp] = useState([]);
	const [searchJob, setSearchJob] = useState([]);
	const [options, setOptions] = useState([]);
	const [page, setPage] = useState(1);
	const [searchRecruiter, setsearchRecruiter] = useState([]);
	const dropdownRef1 = useRef(null);

	// console.log("inputValue", inputValue);

	const addOptions = () => {
		console.log("==========>");
		
		axios
			.get(`/Feature/GlobalSearch?search=${inputValue}`)
			.then((response) => {
				console.log("Response======>", response);
				let data = response.data.data;
				// console.log("Original Data:", data);

				// Process the data to extract the type and followers count
				data = data.map((item) => {
					const [type, followers] = item.type.split(",");
					return {
						...item,
						type,
						followers: parseInt(followers, 10),
					};
				});

				console.log("Processed Data:", data);

				const addUniqueItems = (data, type) => {
					const uniqueItems = data.filter((item) => item.type === type);
					return uniqueItems;
				};

				setSearchComp(addUniqueItems(data, "Company"));
				setSearchJob(addUniqueItems(data, "Job"));
				setsearchRecruiter(addUniqueItems(data, "Recruiter"));

				setIsLoading(false);
				setTotalPages(response.data.responseData);

				setOptions((prev) => {
					const postSet = new Set(prev.map((post) => post.id));
					const uniqueNewPosts = data.filter((post) => !postSet.has(post.id));
					return [...prev, ...uniqueNewPosts];
				});
			})
			.catch((error) => {
				console.log("Error:", error);
			});
	};

	
	useEffect(() => {
		if (inputValue.length >= 3) {
			addOptions(page);
		} else {
			setOptions([]);
			setSearchUser([]);
			setSearchComp([]);
			setSearchJob([]);
			setsearchRecruiter([]);
		}
	}, [inputValue, page]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
				// console.log("Clicked outside, closing dropdown");
				setInputValue("");
				setOptions([])
			}
		};

		document.addEventListener("click", handleClickOutside);
		return () => {
			document.removeEventListener("click", handleClickOutside);
		};
	}, []);

	return (
		<>
			<div className="search-container">
				<SearchOutlined className="searchIcon" />
				<div className="search-input-container">
					<input
						type="text"
						className="input-filter-search"
						placeholder="Search Jobs, Company & Recruiter"
						value={inputValue}
						onChange={(e) => {
							setInputValue(e.target.value);
						}}
					/>
					{(options.length > 0 || inputValue !== "") && (
						<ul className="suggestions-dropdown" ref={dropdownRef1}>
							{/* Show People results */}
							{searchUser.length > 0 && (
								<div style={{ margin: "4px 16px" }}>
									<p style={{ margin: "0", fontWeight: "800" }}>People</p>
								</div>
							)}
							{searchUser.map((item, index) => (
								<Link to={`/Candidate/${item?.entityID}`} key={index}>
									<li
										className="suggestion-item d-flex align-center"
										onClick={() => {
											setOptions([]);
											setInputValue("");
										}}
									>
										<img
											src={item?.image}
											alt=""
											width={30}
											height={30}
											style={{ borderRadius: "50px" }}
										/>
										<div>
											<p className="ms-2">{item?.title}</p>
											<p className="ms-2 f-12 mb-0">{item?.additionalInfo}</p>
											<p className="ms-2 f-12 mb-0">{item?.type}</p>
										</div>
									</li>
								</Link>
							))}

							{/* Show Company results */}
							{searchComp.length > 0 && (
								<div style={{ margin: "4px 16px" }}>
									<p
										style={{
											margin: "0",
											fontWeight: "800",
											fontSize: "20px",
										}}
										className="d-flex"
									>
										Company
									</p>
								</div>
							)}
							{searchComp.map((item, index) => (
								<Link to={`/Company/${item?.entityID}`} key={index}>
									<li
										className="suggestion-item d-flex align-center"
										onClick={() => {
											setOptions([]);
											setInputValue("");
										}}
									>
										<img
											src={item?.image}
											alt=""
											width={30}
											height={30}
											style={{ borderRadius: "50%" }}
										/>
										<div>
											<p className="ms-2 mb-0 text-start">{item?.title}</p>
											<p className="ms-2 f-12 mb-0 text-start">{item?.additionalInfo}</p>
											<p className="f-12 mb-0 ms-2 text-start">{item?.type}</p>
										</div>
									</li>
								</Link>
							))}

							{/* Show Job results */}
							{searchJob.length > 0 && (
								<div style={{ margin: "4px 16px" }}>
									<p
										style={{
											margin: "0",
											fontWeight: "800",
											fontSize: "20px",
										}}
										className="d-flex"
									>
										Job
									</p>
								</div>
							)}
							{searchJob.map((item, index) => (
								<Link to={`/job/${item?.entityID}`} key={index}>
									<li
										className="suggestion-item d-flex  "
										onClick={() => {
											setOptions([]);
											setInputValue("");
										}}
									>
										<div className="search-user-img">
											<img
												src={item.image}
												alt=""
												width={30}
												height={30}
												style={{ borderRadius: "50px" }}
											/>
										</div>
										<div className="">
											<p className="ms-2 mb-0 text-start">{item?.title}</p>
											<p className="ms-2 f-12 mb-0 text-start">{item?.additionalInfo}</p>
											<p className="ms-2 f-12 mb-0 text-start">{item?.type}</p>
										</div>
									</li>
								</Link>
							))}

							{/* Show Post results */}
							{searchRecruiter.length > 0 && (
								<div style={{ margin: "4px 16px" }}>
									<p
										style={{
											margin: "0",
											fontWeight: "800",
											fontSize: "20px",
										}}
										className="d-flex"
									>
										Recruiter
									</p>
								</div>
							)}
							{searchRecruiter.map((item, index) => (
								<Link to={`/Recruiter/${item?.entityID}`} key={index}>
									<li
										className="suggestion-item d-flex align-center"
										onClick={() => {
											setOptions([]);
											setInputValue("");
										}}
									>
										<img
											src={item?.image}
											alt=""
											width={30}
											height={30}
											style={{ borderRadius: "50px" }}
										/>
										<div>
											<p className="ms-2 mb-0 text-start">{item?.title}</p>
											<p className="ms-2 f-12 mb-0 text-start">{item?.additionalInfo}</p>
											<p className="ms-2 f-12 mb-0 text-start">{item?.type}</p>
										</div>
									</li>
								</Link>
							))}

							{/* Show 'No match found' if no results */}
							{searchUser.length === 0 &&
								searchComp.length === 0 &&
								searchJob.length === 0 &&
								searchRecruiter.length === 0 && (
									<li className="no-match-item">
										<p className="text-center mb-0">No match found</p>
									</li>
								)}
						</ul>
					)}
				</div>

			</div>


			{/* </div> */}
		</>
	);
};

export default GobalSearch;
